import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  onLine: {
    color: theme.palette.success.main,
  },
  offLine: {
    color: theme.palette.error.main,
  },
}));
